import { onCLS, onFCP, onLCP, onTTFB, onINP, type Metric } from 'web-vitals';
import * as Sentry from '@sentry/react';

/**
 * Report Web Vitals metrics to Sentry and console
 * 
 * This helps monitor Core Web Vitals:
 * - LCP (Largest Contentful Paint)
 * - INP (Interaction to Next Paint) - replaces FID
 * - CLS (Cumulative Layout Shift)
 * - FCP (First Contentful Paint)
 * - TTFB (Time to First Byte)
 */
export const reportWebVitals = () => {
  const sendToSentry = (metric: Metric) => {
    // Send to Sentry as measurement for performance monitoring
    try {
      Sentry.metrics.distribution(metric.name, metric.value, {
        unit: metric.name === 'CLS' ? undefined : 'millisecond',
      });
    } catch (error) {
      // Fallback if Sentry metrics API is not available
      console.warn('Sentry metrics not available:', error);
    }

    // Log to console in development
    if (import.meta.env.DEV) {
      console.log(`[Web Vitals] ${metric.name}:`, {
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
      });
    }
  };

  // Core Web Vitals
  onCLS(sendToSentry); // Cumulative Layout Shift
  onINP(sendToSentry); // Interaction to Next Paint (replaces FID)
  onLCP(sendToSentry); // Largest Contentful Paint
  onFCP(sendToSentry); // First Contentful Paint
  onTTFB(sendToSentry); // Time to First Byte
};







